import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  max-width: 480px;
  width: 80vw;

  header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;

    .stop {
      display: flex;
      flex-direction: column;
      gap: 4px;

      .label {
        color: ${ ({ theme }) => theme.colors.greyDark };
        font-size: 14px;
        text-transform: uppercase;
      }

      .name {
        color: ${ ({ theme }) => theme.colors.black };
        font-size: 20px;
        font-weight: 700;
      }
    }

    .close {
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      display: flex;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }

  .days-question {
    color: ${ ({ theme }) => theme.colors.greyDark };
    font-size: 15px;
  }

  .days {
    display: flex;
    flex-direction: row;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 4px;

    .day {
      flex: 0 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2px;
      min-width: 84px;
      padding: 8px 12px;
      border-radius: 8px;
      border: 1px solid ${ ({ theme }) => theme.colors.greyLight };
      background-color: ${ ({ theme }) => theme.colors.white };
      cursor: pointer;
      font-size: 14px;
      color: ${ ({ theme }) => theme.colors.black };

      &.selected {
        border-color: ${ ({ theme }) => theme.colors.greenRadio };
        background-color: ${ ({ theme }) => theme.colors.lightGreen };
      }

      &.disabled {
        opacity: 0.5;
        cursor: default;
      }

      .weekday {
        font-weight: 700;
        white-space: nowrap;
      }
    }
  }

  .availabilities {
    display: flex;
    flex-direction: column;
    max-height: 40vh;
    overflow-y: auto;

    .availability {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 12px;
      padding: 12px 8px;
      border-bottom: 1px solid ${ ({ theme }) => theme.colors.greyLight };
      border-radius: 8px;
      cursor: pointer;

      &:hover {
        background-color: ${ ({ theme }) => theme.colors.almostWhite };
      }

      &:last-child {
        border-bottom: none;
      }

      .time {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 6px;
        min-width: 92px;
        font-size: 16px;
        color: ${ ({ theme }) => theme.colors.black };

        img {
          width: 18px;
          height: 18px;
        }
      }

      .destination {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;
        flex: 1;
        min-width: 0;

        span {
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .state {
        color: ${ ({ theme }) => theme.colors.greyDark };
        font-size: 14px;
        text-align: right;
        white-space: nowrap;
      }
    }
  }

  .tag {
    flex: 0 0 auto;
    min-width: 28px;
    padding: 2px 6px;
    border-radius: 6px;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
  }

  footer {
    display: flex;
    flex-direction: row;
  }

  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 24px 0;
    text-align: center;

    .title {
      font-weight: 700;
      color: ${ ({ theme }) => theme.colors.black };
    }

    .description {
      color: ${ ({ theme }) => theme.colors.greyDark };
      font-size: 14px;
    }
  }
`
